import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { Alert } from '../../domain/models';
import * as fromNotfAlertActions from './alert.actions';
import { LocalizedText } from '@common/models';

export const NotfAlertFeatureKey = 'alert';

export interface INotfAlertState extends EntityState<Alert>
{
    alerts: Alert[];
    qsWord: string;
}

export const adapter: EntityAdapter<Alert> = createEntityAdapter<Alert>({
    selectId: (alert: Alert) => alert.id
});

export const initialState: INotfAlertState = adapter.getInitialState({
    alerts: [],
    qsWord: ''
});

export const NotfAlertReducer = createReducer(
    initialState,
    on(
        fromNotfAlertActions.NotfAlertLoadSucceeded,
        (state: INotfAlertState, { alerts }: { alerts: Alert[] }) =>
            adapter.addMany(alerts, adapter.removeAll(state))
    ),
    on(
        fromNotfAlertActions.NotfAlertsSucceeded,
        (state, { alerts }) =>
            ({
                ...adapter.setAll(alerts, state),
                alerts
            })
    ),
    on(
        fromNotfAlertActions.NotfAlertsQsWordSet,
        (state, { qsWord }: { qsWord: string; }) =>
            ({
                ...state,
                qsWord: qsWord.toLowerCase()
            })
    ),
    on(
        fromNotfAlertActions.NotfAlertsDisableSucceeded,
        (state, { alertId }) =>
            ({
                ...state,
                alerts: state.alerts.map(a =>
                {
                    if (a.id === alertId)
                    {
                        a.active = false;
                    }

                    return a;
                })
            })
    ),
    on(
        fromNotfAlertActions.NotfAlertsActivateSucceeded,
        (state, { alertId }) =>
            ({
                ...state,
                alerts: state.alerts.map(a =>
                {
                    if (a.id === alertId)
                    {
                        a.active = true;
                    }

                    return a;
                })
            })
    ),
    on(
        fromNotfAlertActions.NotfAlertsDeleteSucceeded,
        (state, { alertId }) =>
            ({
                ...state,
                alerts: state.alerts.filter(a => a.id !== alertId)
            })
    ),
    on
    (
        fromNotfAlertActions.NotfCreateAlertSucceeded,
        (state, alert) =>
        {
            const alerts = state.alerts;
            alerts.push(alert);
            
            return {
                ...state,
                alerts: alerts
            }
        }
    ),
    on(
        fromNotfAlertActions.NotfUpdateAlertSucceeded,
        (state, alert) => ({
            ...state,
            alerts: state.alerts.map(a =>
                {
                    if (a.id == alert.id) {
                        a.text = alert.text;
                        a.title = alert.title;
                        a.rangeActivation.since = alert.rangeActivation.since;
                        a.rangeActivation.until = alert.rangeActivation.until;
                    }
                    return a;
                }
            )
        })
    )
);
